import {defineStore} from 'pinia'

/**
 * Note that when we are refreshing the filter log or if the connectd is changed, the entire store is reset.
 *
 */
export const useInformationStore = defineStore('information', {
    state: () => {
        return {
            unboundLogTxt: [],
            unboundLogJson: [],
            connectedUsers: [],
            connectedUsersStatusFilterOptions: [],
            informationProgressBar: false,
            idefixStatusDev: [],
            idefixStatus: [],
        }
    },
    actions: {
        setUnboundLogTxt(unboundLogTxt) {
            this.unboundLogTxt = unboundLogTxt
        },
        setUnboundLogJson(unboundLogJson) {
            this.unboundLogJson = unboundLogJson
        },
        setConnectedUsers(connectedUsers) {
            this.connectedUsers = connectedUsers
        },
        setConnectedUsersStatusFilterOptions(connectedUsersStatusFilterOptions) {
            this.connectedUsersStatusFilterOptions = connectedUsersStatusFilterOptions
        },
        setIdefixStatusDev(idefixStatusDev) {
            this.idefixStatusDev = idefixStatusDev
        },
        setIdefixStatus(idefixStatus) {
            this.idefixStatus = idefixStatus;
        }

    },
    getters: {}

})
